import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Utils } from 'src/app/services/utils/utils.service';
import { environment } from '../../../environments/environment';
import { ContentText } from '../../models/content-text';
import { NewPlanOption } from '../../models/new-plan-option';
import { VehicleDetail } from '../../models/vehicle-detail';
import { SAPDataService } from '../../services/sap/sap-data.service';
import { SharedStateService } from '../../services/shared-state/shared-state.service';
import { CustomizePlanComponent } from '../customize-plan/customize-plan.component';

@Component({
  selector: 'app-select-plan',
  templateUrl: './select-plan.component.' + environment.brand + '.html',
  styleUrls: ['./select-plan.component.' + environment.brand + '.scss'],
  providers: [SAPDataService]
})
export class SelectPlanComponent implements AfterViewInit {
  @ViewChild('customizePlan') customizePlan: CustomizePlanComponent;
  contentTexts: ContentText[] = [];
  selectedVehicleDetail: VehicleDetail;
  newPlanOptions: NewPlanOption[];
  get justBrowsing(): boolean {
    return this.sharedStateService.justBrowsing;
  }

  get isPlanTypeUnknown(): boolean {
    return this.selectedVehicleDetail && this.selectedVehicleDetail.planType == "I don't know";
  }

  constructor(private sharedStateService: SharedStateService,
    private sapDataService: SAPDataService,
    private utils: Utils) {
    //console.log('SelectPlanComponent.constructor');
    if (!this.sharedStateService.ownerInfo && !this.sharedStateService.justBrowsing) {
      this.sharedStateService.showStart();
      return;
    }

    // get dynamic text
    const pageName = 'Select Plan';
    this.contentTexts = this.sharedStateService.contentTexts.filter(x => x.pageName == pageName);
    if (this.contentTexts.length == 0) {
      this.sharedStateService.onContentTextLoaded.subscribe(() => {
        this.contentTexts = this.sharedStateService.contentTexts.filter(x => x.pageName == pageName);
      });
    }
  }

  ngAfterViewInit(): void {
    //console.log('SelectPlanComponent.ngAfterViewInit');
    this.selectedVehicleDetail = this.sharedStateService.selectedVehicleDetail;
    this.utils.log(JSON.stringify(this.selectedVehicleDetail));
    this.getRecommendedPlans();
  }

  getRecommendedPlans(): void {
    if (!this.selectedVehicleDetail) {
      return;
    }

    // decide which service call to use
    let getRecommendedPlans;
    if (!this.sharedStateService.justBrowsing) {
      getRecommendedPlans = this.sapDataService.getRecommendedPlans(this.selectedVehicleDetail.vin, this.selectedVehicleDetail.currentOdometer);
    } else {
      getRecommendedPlans = this.sapDataService.getRecommendedPlansJustBrowsing(
        this.selectedVehicleDetail.brandCode,
        this.selectedVehicleDetail.segment,
        this.selectedVehicleDetail.planType,
        this.selectedVehicleDetail.currentPlanEndKM,
        this.selectedVehicleDetail.currentPlanYears,
        +this.selectedVehicleDetail.year,
        this.selectedVehicleDetail.currentOdometer);
    }

    this.newPlanOptions = [];
    this.sharedStateService.toggleLoader(true);
    getRecommendedPlans
      .pipe(finalize(() => {
        this.sharedStateService.toggleLoader(false);
      }))
      .subscribe(recommendedPlans => {
        if (recommendedPlans) {
          //console.log('recommended plans', JSON.stringify(recommendedPlans));
          this.newPlanOptions = recommendedPlans;
          this.customizePlan.loadPlanTypeOptions();
        }
      }, error => {
        //console.log('getRecommendedPlans', error);
        this.sharedStateService.showDialog({
          isVisible: true,
          header: 'Error getting recommended plans',
          message: 'Please try again or contact us for assistance.'
        });
      });
  }

  onBackToCustomerDetails(): void {
    if (!this.sharedStateService.justBrowsing) {
      this.sharedStateService.newPlanOption = undefined;
      this.sharedStateService.showCustomerDetails();
    } else {
      this.sharedStateService.showJustBrowsingVehicleDetails();
    }
  }
}
